<template>
<!-- start header -->
<div id="header-part">
    <div class="container max-1762">
        <div class="row">
            <div class="logo">
                <router-link to="/">
                    <img src="../assets/images/logo.svg"/>
                </router-link>
            </div>
            <div class="menu">
                <ul class="sociallinks">
                    <li><a href="#"><i class="d-none fab fa-facebook-square"></i></a></li>
                    <li><a href="#"><i class="d-none fab fa-twitter-square"></i></a></li>
                </ul>
                <div class="mtoggle" @click="toggleMenu">
                    <div class="bar1"></div>
                    <div class="bar2"></div>
                </div>
                <div class="nav" id="nav-menu">
                    <ul>
                        <li @click="toggleMenu">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li @click="toggleMenu">
                            <router-link to="/services">Onze Services</router-link>
                        </li>
                        <li @click="toggleMenu">
                            <router-link to="/culture">Waarom werken bij Mirzacles?</router-link>
                        </li>
                        <li @click="toggleMenu">
                            <router-link to="/vacancies">Vacatures</router-link>
                        </li>
                        <li @click="toggleMenu">
                            <router-link to="/contact">Contact</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end header -->
</template>

<style scoped>

.logo {
    width: 325px;
}
.logo a {
    margin-left: 0 !important;
    display: block;
}
.logo img {
    max-width: 100%;
}

.mtoggle [class^="bar"] {
    pointer-events: none;
}

#nav-menu {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
}

#nav-menu.active {
    opacity: 1;
}
</style>

<script>
export default {
    data() {
        return {
            menuOpen: false
        }
    },
    methods: {
        toggleMenu: function (e) {
            const target = document.querySelector('.mtoggle');
            const menu = document.querySelector('#nav-menu');
            this.menuOpen = !this.menuOpen;

            if (this.menuOpen) {
                target.classList.add('active');
                menu.style.display = 'block';
                setTimeout(() => {
                    menu.classList.add('active');
                }, 0);

            } else {
                menu.classList.remove('active');
                target.classList.remove('active');
                setTimeout(() => {
                    menu.style.display = 'none';
                }, 350);
            }
            
        }
    }
}
</script>